import { gql } from "@apollo/client";export default gql`mutation AddPlanTagMap($objects: [subscription_plan_tag_map_insert_input!]!) {
  addPlanTagMap: insert_subscription_plan_tag_map(objects: $objects) {
    affected_rows
  }
}
`;
